import {cva} from 'class-variance-authority';

export const collapsibleVariants = cva('flex flex-col', {
  variants: {
    variant: {
      default: 'gap-2',
      section: 'gap-3',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export const collapsibleTriggerVariants = cva(
  'flex w-full cursor-pointer items-center gap-2 rounded-sharp text-left focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none [&[data-state=closed]>svg:first-child]:-rotate-90',
  {
    variants: {
      variant: {
        default: 'py-2',
        section: 'py-0',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export const collapsibleContentVariants = cva(
  'overflow-hidden data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down',
  {
    variants: {
      variant: {
        default: '',
        section: 'flex flex-col gap-3',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
